import { mapGetters } from 'vuex';
import rootTypes from '@/store/types';
import { ALMA_TERRITORIES } from '@/modules/dashboard/constants/alma-countries';

export default {
  computed: {
    ...mapGetters({
      doctorCountry: rootTypes.getters.GET_USER_COUNTRY
    }),
    isAlmaTerritory() {
      return ALMA_TERRITORIES.includes(this.doctorCountry);
    }
  }
};
